module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad1/img_activities01-b53d6db19c7fd02c71cd77ed8101d9ae.jpg";